// Fields where selection validation should be triggered. Used as dependency list in react-hook-form register method.
export const elektrisitetSelectionFields = [
  'elektrisk.value.panelovn.selected',
  'elektrisk.value.gulvvarme.selected',
  'elektrisk.value.takvarme.selected',
  'elektrisk.value.luftvarme.selected',
  'elektrisk.value.elektrokjel.selected'
];
